import { FC, ReactNode, useState } from 'react';
import { Typography } from '@hapvida/hapvida-core-components';

import {
  Image,
  StyledPaper,
  LightTooltip,
  MessageWrapper,
  StyledTypography,
  StyledSubTitle,
} from './styles';
import { Divider, Stack } from '@mui/material';
import Icon from '../Icon';
import { COLORS } from '../../themes/colors';
interface NavigationCardProps {
  enableImage: string;
  disabledImage: string;
  messageOne?: string;
  messageTwo?: string;
  disabled?: boolean;
  disabledMessageOne?: ReactNode;
  disabledMessageTwo?: ReactNode;
  handlerAction?: () => void;
  fullWidth?: boolean;
}

const NavigationCard: FC<NavigationCardProps> = ({
  enableImage,
  disabledImage,
  messageOne,
  messageTwo,
  disabled = false,
  disabledMessageOne,
  disabledMessageTwo,
  handlerAction,
  fullWidth = false,
}) => {
  const [tooltipOpen, setTooltipOpen] = useState(false);

  return (
    <LightTooltip
      open={!!(disabledMessageOne || disabledMessageTwo) && tooltipOpen}
      title={
        <Stack
          gap={1}
          sx={{
            padding: '25px 20px',
            background: 'white',
            borderRadius: '8px',
          }}
        >
          {disabledMessageOne && (
            <Stack direction="row" gap={1} alignItems="center">
              <Icon
                name="alert"
                color={COLORS.SECONDARY.YELLOW['+1']}
                size={32}
              />
              <Divider orientation="vertical" flexItem />
              <Typography variant="text">{disabledMessageOne}</Typography>
            </Stack>
          )}
          {disabledMessageTwo && (
            <Typography variant="text">{disabledMessageTwo}</Typography>
          )}
        </Stack>
      }
      arrow
      disableHoverListener={!disabled}
    >
      <StyledPaper
        disabled={disabled}
        onClick={() => !disabled && handlerAction && handlerAction()}
        onMouseOver={() => disabled && setTooltipOpen(true)}
        onMouseLeave={() => setTooltipOpen(false)}
        fullWidth={fullWidth}
      >
        <Stack alignItems="center">
          <Image src={disabled ? disabledImage : enableImage} />
        </Stack>
        <MessageWrapper fullWidth={fullWidth}>
          {messageOne && (
            <StyledTypography
              disabled={disabled}
              variant="subtitle1"
              sx={{ whiteSpace: 'nowrap' }}
            >
              {messageOne}
            </StyledTypography>
          )}
          {messageTwo && (
            <StyledSubTitle disabled={disabled} variant="text">
              {messageTwo}
            </StyledSubTitle>
          )}
        </MessageWrapper>
      </StyledPaper>
    </LightTooltip>
  );
};

export default NavigationCard;
